function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\n        icon-trash\n    ");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.51,55.5H23.42a4.2,4.2,0,0,1-4.19-4.18L17.32,21.51c0-2.31,4-2.1,6.28-2.1H40.33c2.31,0,6.28-.21,6.28,2.1L44.7,51.32A4.2,4.2,0,0,1,40.51,55.5Z",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 24.49,
  y: 25.17,
  width: 1.35,
  height: 23.01,
  rx: 0.5,
  transform: "matrix(1, -0.03, 0.03, 1, -1.26, 0.9)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 31.4,
  y: 22.55,
  width: 1.13,
  height: 27.2,
  rx: 0.5,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 38.16,
  y: 25.17,
  width: 1.21,
  height: 23.01,
  rx: 0.5,
  transform: "translate(1.3 -1.33) rotate(2)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 15.3,
  width: 38,
  height: 3.82,
  rx: 1.91,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 24.12,
  y: 11,
  width: 15.69,
  height: 4,
  rx: 1,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.91b58a49.svg";
export { ForwardRef as ReactComponent };